export default __webpack_public_path__ + "0ed4953ab75b6bbdd0624cbd8f4c459e.ico";